// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_66X","rootNoMargin":"styles_rootNoMargin__1_aOE"};